import { Configuration, ConfigurationParameters } from "../api";

export function apiConfigFactory(): Configuration {

    const params: ConfigurationParameters = {
      basePath: sessionStorage.getItem('endpoint'),
    };

    return new Configuration(params);
  }